module.exports = __webpack_public_path__ + "assets/img/user.8223b3f4.png";